const trackingUtils = require('od-modules/utils/tracking.utils');

const getBookingId = ({bookingId} = {}) => bookingId;
const getNumOfFlights = ({numOfFlights} = {}) => numOfFlights;

const isDP = () => Odigeo.SessionScope.flowProduct === 'dp';
const isTripDetails = () => Odigeo.History.getPageNameFromFragment() === 'tripdetails';

const getTrackingData = (bookingData, status) => {
    const flowProductTag = isDP() ? 'dp' : 'fl';
    const pageTag = isTripDetails() ? 'ar' : 'tr';
    return {
        numFlights: getNumOfFlights(bookingData),
        step: `${status.currentStep}/${status.totalSteps}`,
        bookingID: getBookingId(bookingData),
        page: Odigeo.History.getPageNameFromFragment(),
        pageLabel: `my${pageTag}${flowProductTag}`,
    };
};

const onLoadTracking = (bookingData, status) => {
    const data = getTrackingData(bookingData, status);
    trackingUtils.trackEvent('cancellation',
        `booking:${data.numFlights}_canc-status-onload_step:${data.step}_id:${data.bookingID}_pag:${data.pageLabel}`, data.page);
};

const onClickTracking = (bookingData, status) => {
    const data = getTrackingData(bookingData, status);
    trackingUtils.trackEvent('cancellation',
        `booking:${data.numFlights}_canc-status-click_step:${data.step}_id:${data.bookingID}_pag:${data.pageLabel}`, data.page);
};

module.exports = {
    onLoadTracking,
    onClickTracking,
};
